import request from '@/services/request'
import { getApiUrl } from '@/utils/tool'

export function getMyBanks() {
  return request({
    baseURL: getApiUrl(),
    url: '/bank',
    method: 'post',
    data: {}
  })
}

export function createBankCard(object) {
  return request({
    baseURL: getApiUrl(),
    url: '/bank/create',
    method: 'post',
    data: object
  })
}

export function deleteBankCard(object) {
  return request({
    baseURL: getApiUrl(),
    url: '/bank/delete',
    method: 'post',
    data: object
  })
}

export function getAllBankByCurrency(type) {
  return request({
    baseURL: getApiUrl(),
    url: '/bank/all-bank-by-currency',
    method: 'post',
    data: {
      type: type
    }
  })
}

export function getMyCreditCards() {
  return request({
    baseURL: getApiUrl(),
    url: '/creditcard/get-cards',
    method: 'post',
    data: {}
  })
}

export function createCreditCard(object) {
  return request({
    baseURL: getApiUrl(),
    url: '/creditcard/create',
    method: 'post',
    data: object
  })
}

export function deleteCreditCard(object) {
  return request({
    baseURL: getApiUrl(),
    url: '/creditcard/delete',
    method: 'post',
    data: object
  })
}

export function getStateCode(object) {
  return request({
    baseURL: getApiUrl(),
    url: '/creditcard/get-state-code',
    method: 'post',
    data: object
  })
}
